const Backbone = require('backbone');
const Mn = require('backbone.marionette');
require('backbone.stickit');
const Template = require('jiji/ui/template/content/login/index.hbs');
const LoginTemplate = require('jiji/ui/template/content/login/jiji-login.hbs');
const API = require('jiji/infra/api/user');

const LoginForm = Backbone.Model.extend({});

const JijiLoginView = Mn.View.extend({
    template: LoginTemplate,
    bindings: {
        '.loginID': 'loginID',
        '.loginPassword': 'password'
    },
    ui: {
        loginButton: '.login-button'
    },
    events: {
        'click @ui.loginButton': 'login'
    },

    onRender: function () {
        this.stickit();
    },

    login: function () {
        API.idlogin(this.model.toJSON()).then(() => {
            const params = new URLSearchParams(location.search);

            if (params.get('from')) {
                location.href = decodeURIComponent(params.get('from'));
            } else {
                location.href = "/";
            }
        });
    }
});

module.exports = Mn.View.extend({
    template: Template,
    ui: {
        google: '.google',
        quadcept: '.quadcept'
    },
    events: {
        'click @ui.google': 'google',
        'click @ui.quadcept': 'quadcept'
    },
    regions: {
        jijiLogin: '.jiji-login'
    },

    google: function() {
        location.href = `/auth/google/login${location.search}`;
    },

    quadcept: function() {
        location.href = `/auth/quadcept/login${location.search}`;
    },

    onRender: function () {
        const params = new URLSearchParams(location.search);
        if (params.get('autoRedirect') === 'google') {
            this.google();
            return this;
        }
        if (params.get('autoRedirect') === 'quadcept') {
            this.quadcept();
            return this;
        }

        if (params.get('idLogin')) {
            this.showChildView('jijiLogin', new JijiLoginView({
                model: new LoginForm()
            }));
        }

        return this;
    }
});



// WEBPACK FOOTER //
// ./jiji/ui/view/content/login/index.js